// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  fill: "ScrollProgress__fill",
  track: "ScrollProgress__track",
  wrapper: "ScrollProgress__wrapper",
};
